module.exports = __webpack_public_path__ + "static/Background-TDF-Awards-39626ac4b0be3c0985cd3cd068f8a300.jpg";